module.exports = __webpack_public_path__ + "static/media/diwata2.774421c7.glb";